import { render, staticRenderFns } from "./HighSchoolEOIDetails.vue?vue&type=template&id=148a94a9&scoped=true&"
import script from "./HighSchoolEOIDetails.vue?vue&type=script&lang=js&"
export * from "./HighSchoolEOIDetails.vue?vue&type=script&lang=js&"
import style0 from "./HighSchoolEOIDetails.vue?vue&type=style&index=0&id=148a94a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148a94a9",
  null
  
)

export default component.exports